import "./App.css";
import "./css/innerPages.css";
import "./css/loader.css";
import Login from "./pages/login/Login";
import { Route, Routes, HashRouter, Navigate } from "react-router-dom";
import Success from "./pages/Success";
import BookingId from "./pages/initialpages/BookingId";
import Home from "./pages/initialpages/Home";
import HotelList from "./pages/initialpages/HotelList";
import Hotelguide from "./pages/hotelGuide/Hotelguide";
import Spa from "./pages/spa/Spa";
import SpaCatagory from "./pages/spa/SpaCatagory";
import SpaRequest from "./pages/spa/SpaRequest";
import TouristGuide from "./pages/tourist/TouristGuide";
import TouristPlace from "./pages/tourist/TouristPlace";
import Event from "./pages/event/Event";
import EventRequest from "./pages/event/EventRequest";
import CheckOut from "./pages/OtherService/CheckOut";
import ExtendStay from "./pages/OtherService/ExtendStay";
import RoomChange from "./pages/OtherService/RoomChange";
import WakeUp from "./pages/OtherService/WakeUp";
import PickNdrop from "./pages/pickDrop/PickNdrop";
import Resturants from "./pages/indoorDining/Resturants";
import TableReserve from "./pages/TableReservation/TableReserve";
import TableRequest from "./pages/TableReservation/TableRequest";
import FoodItems from "./pages/indoorDining/FoodItems";
import HouseKeeping from "./pages/houseKeeping/HouseKeeping";
import SpotMyRoom from "./pages/room/SpotMyRoom";
import Myprofile from "./pages/profile/Myprofile";
import HotelGuideItem from "./pages/hotelGuide/HotelGuideItem";
import Explore from "./pages/explore/Explore";
import HotelData from "./pages/explore/HotelData";
import ProfileHistory from "./pages/profile/ProfileHistory";
import EventInnerPage from "./pages/explore/EventInnerPage";
import TicketsList from "./pages/profile/TicketsList";
import AppLayout from "./layout/AppLayout";
import PromotionList from "./pages/promotions/PromotionList";
import OrderHistoryPage from "./pages/history/OrderHistoryPage";
import TablePage from "./components/TableModal";
import { useEffect } from "react";
import { onMessage } from "firebase/messaging";
 
 import ReactGA from "react-ga4";
import { AnalyticsKey } from "./constants/Api";

function App() {


  

  //Google Analytics Key
  ReactGA.initialize(AnalyticsKey);

  return (
    <HashRouter>
      <AppLayout>
        <Routes basename="/guestweb-release/">
          <Route path="/" element={<Explore />}></Route>
          <Route path="/hotel-detail/:id" element={<HotelData />}></Route>
          <Route path="/login" element={<Login />}></Route>
          <Route path="success" element={<Success />}></Route>
          <Route path="booking-id" element={<BookingId />}></Route>
          <Route path="home" element={<Home />}></Route>
          <Route path="home/:id" element={<Home />}></Route>
          <Route path="hotel-list" element={<HotelList />}></Route>
          <Route path="hotel-guide/:id" element={<Hotelguide />}></Route>
          <Route
            path="hotel-guide-detail/:id"
            element={<HotelGuideItem />}
          ></Route>
          <Route path="spa/:id" element={<Spa />}></Route>
          <Route path="spa-catagory/:id" element={<SpaCatagory />}></Route>
          <Route path="spa-request" element={<SpaRequest />}></Route>
          <Route path="tourist-guide/:id" element={<TouristGuide />}></Route>
          <Route path="tourist-place/:id" element={<TouristPlace />}></Route>
          <Route path="event/:id" element={<Event />}></Route>
          <Route path="event-request/:id" element={<EventRequest />}></Route>
          <Route path="check-out" element={<CheckOut />}></Route>
          <Route path="extend-stay" element={<ExtendStay />}></Route>
          <Route path="room-change" element={<RoomChange />}></Route>
          <Route path="wakeup-call" element={<WakeUp />}></Route>
          <Route path="pick-and-drop/:id" element={<PickNdrop />}></Route>
          <Route
            path="table-reservation/:id"
            element={<TableReserve />}
          ></Route>
          <Route path="table-request" element={<TableRequest />}></Route>
          <Route path="resturants/:id" element={<Resturants />}></Route>
          <Route path="food-items/:id" element={<FoodItems />}></Route>
          <Route path="/house-keeping/:id" element={<HouseKeeping />}></Route>
          <Route path="/spot-my-room" element={<SpotMyRoom />}></Route>
          <Route path="/profile" element={<Myprofile />}></Route>
          <Route path="/profile-history" element={<ProfileHistory />}></Route>
          <Route path="/event-details/:id" element={<EventInnerPage />}></Route>
          <Route path="/tickets" element={<TicketsList />}></Route>
          <Route path="/tablereservation-form" element={<TablePage />}></Route>

          <Route path="/offers" element={<PromotionList />}></Route>
          <Route path="/order-history" element={<OrderHistoryPage />}></Route>
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </AppLayout>
    </HashRouter>
  );
}

export default App;
